import * as React from 'react';
import { IListItem } from '../../common/classes/list-item';

import { LocationListItem } from '../../location/components/list-item';
import ProviderListItem from '../../provider/components/list-item';
import { EventListItem } from '../../event/components/list-item';
import { CareListItem} from './care-list-item'

export type IProviderListItemProps = IListItem;

export const GenericListItem: React.StatelessComponent<IProviderListItemProps> = props => {
    if (props.typeOfResult == "ProviderDetailResult") {
        return (
            <ProviderListItem key={props.id} {...props} />
        );
    }
    else if (props.typeOfResult == "LocationDetailResult") {
        return (
            <LocationListItem key={props.id} {...props} />
        );
    }
    else if (props.typeOfResult == "EventDetailResult") {
        return (
            <EventListItem key={props.id} {...props} />
        );
    }
    else if (props.typeOfResult == "GenericSearchResult") {
        return (
            <CareListItem key={props.id} {...props} />
        );
    }
    else return <div>error: unknown item type</div>;

}